import React from "react"
import { useLocation } from "react-router-dom"
import * as layouts from "layouts"
import * as routing from "brandguard/display/training/routing"
import { Link } from "react-router-dom"
import * as brands from "brands"
import * as titlebars from "titlebars"
import * as debugx from "x/debugx"

interface props {
	title: string
	urlgen(bid: string): string
}

export function ActiveLink(props: props): JSX.Element {
	const brand = brands.caching.useCached()
	const location = useLocation()
	const link = props.urlgen(brand.id)
	const isactive = location.pathname === link
	return (
		<layouts.containers.flex pr="2px">
			<Link to={link}>
				<titlebars.navigation.Button
					width="120px"
					height="40px"
					disabled={isactive}
					className={`${isactive ? "active" : ""}`}
				>
					{props.title}
				</titlebars.navigation.Button>
			</Link>
		</layouts.containers.flex>
	)
}

export function NavContainer(props: React.PropsWithChildren<layouts.containers.FlexProps>): JSX.Element {
	const { children, ...rest } = props
	return (
		<layouts.containers.flex
			flexDirection="row"
			borderRadius="10px"
			mb="10px"
			mt="5px"
			background={layouts.theme.colors.white}
			{...rest}
		>
			{children}
		</layouts.containers.flex>
	)
}

export function ImagesNav(): JSX.Element {
	return (
		<NavContainer>
			{debugx.alpha.enabled() && <ActiveLink title="Suggestions" urlgen={routing.image.review} />}
			<ActiveLink title="Trained" urlgen={routing.image.upload} />
			<ActiveLink title="Settings" urlgen={routing.image.settings} />
		</NavContainer>
	)
}

export function DocumentsNav(): JSX.Element {
	return (
		<NavContainer>
			<ActiveLink title="Trained" urlgen={routing.document.upload} />
			<ActiveLink title="Settings" urlgen={routing.document.settings} />
		</NavContainer>
	)
}

export function TextsNav(): JSX.Element {
	return (
		<NavContainer>
			{debugx.alpha.enabled() && <ActiveLink title="Suggestions" urlgen={routing.text.review} />}
			<ActiveLink title="Trained" urlgen={routing.text.upload} />
			<ActiveLink title="Settings" urlgen={routing.text.settings} />
		</NavContainer>
	)
}

export function VideosNav(): JSX.Element {
	return (
		<NavContainer>
			<ActiveLink title="Trained" urlgen={routing.video.upload} />
			<ActiveLink title="Settings" urlgen={routing.video.settings} />
		</NavContainer>
	)
}
